

















import { Component, Prop, Vue } from "vue-property-decorator";
import { Fragment } from "vue-fragment";
import { DataValidation, ReportStep } from "@/models/graphql-global-types";
import { NewReportStore } from "@/store/NewReportStore";
import { ReportFilterStore } from "@/store/ReportFilterStore";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import CharacteristicTitle from "@/components/reports/partials/show/characteristic-title.vue";

@Component({
  components: { ClipLoader, Fragment }
})
export default class ReportFilterProgressCard extends Vue {
  private ReportStep = ReportStep;
  @Prop() private step!: string;

  get reports() {
    return ReportFilterStore.filteredReports.filter(r => r.step === this.$props.step);
  }

  get loading() {
    return NewReportStore.loading;
  }
  get initialLoadDone() {
    return NewReportStore.initialLoadDone;
  }
  get selectedSteps() {
    return ReportFilterStore.reportSteps;
  }

  public onSelect() {
    ReportFilterStore.setReportStep(this.$props.step);
  }

  public calcValidation() {
    const validations = this.reports.map(r => r.dataValidation);
    if (validations.includes(DataValidation.TESTED_NOK_CRITICAL)) {
      return DataValidation.TESTED_NOK_CRITICAL;
    } else if (validations.includes(DataValidation.TESTED_NOK)) {
      return DataValidation.TESTED_NOK;
    } else if (validations.includes(DataValidation.TESTED_OK)) {
      return DataValidation.TESTED_OK;
    } else if (validations.includes(DataValidation.NOT_TESTED)) {
      return DataValidation.NOT_TESTED;
    }
    return "empty";
  }
}
